export default "__VITE_ASSET__DOxEXVId__"